<div class="col-12 text-secondary mb-1">
  <small><b>
    Fechas de cobro de mantenimiento programadas
  </b></small>
</div>

<div class="col-12 bg-white px-3 rounded mb-4 py-3">
  <div class="row">

    <div class="col-12 d-flex justify-content-end mb-3">
      <button
        (click)="onCreateCycle()"
        class="btn btn-success rounded-circle me-2">
        <i class="material-icons mt-1">add</i>
      </button>
      <button
        (click)="loadChargesCycles()"
        class="btn btn-primary rounded-circle">
        <i class="material-icons mt-1">refresh</i>
      </button>
    </div>

    <div class="col-12">
      <p-table
        [value]="chargesCycles"
        [loading]="chargesCycleService.loading"
        [rowHover]="true">

        <ng-template pTemplate="header">
          <tr>
            <th>Día de corte</th>
            <th>Día límite de pago</th>
            <th></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-cycle>
          <tr class="p-selectable-row">

            <td>
              <span class="p-column-title">Día de corte</span>
              {{ cycle.cutoffDay }} del mes
            </td>

            <td>
              <span class="p-column-title">Día límite de pago</span>
              {{ cycle.maxPaymentDay }} del mes
            </td>

            <td class="text-end">
              <button
                (click)="onUpdateCycle(cycle)"
                class="btn btn-sm btn-light rounded-circle me-2 my-1">
                <i class="material-icons mt-1">edit</i>
              </button>
              <button
                (click)="onDeleteCycle(cycle.chargesCycleId)"
                class="btn btn-sm btn-danger rounded-circle me-2 my-1">
                <i class="material-icons mt-1">delete</i>
              </button>
            </td>

          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="3" class="text-center text-secondary py-3">
              No hay ciclos de cobro registrados
            </td>
          </tr>
        </ng-template>

      </p-table>
    </div>

  </div>
</div>
